module.exports = __webpack_public_path__ + "img/child.6fdc6e9b.svg";